// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3r5pQJOF3yDa0Y {\n  color: #FFFFFF;\n}\n.CKyIHbTuqcsJb6 {\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 3px;\n  clear: both;\n  display: block;\n  float: left;\n  margin: 0 0 4px 8px;\n  text-decoration: none;\n  transition: transform 85ms ease-in;\n  color: hsl(0, 0%, 90%);\n  padding: 6px 12px 6px 10px;\n}\n.CKyIHbTuqcsJb6:hover {\n  background: rgba(0, 0, 0, 0.8);\n  color: #FFFFFF;\n  transform: translateX(5px);\n}\n._1jRGaRMtc1BCZw {\n  margin-left: 6px;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": "_3r5pQJOF3yDa0Y",
	"button": "CKyIHbTuqcsJb6",
	"buttonLabel": "_1jRGaRMtc1BCZw"
};
export default ___CSS_LOADER_EXPORT___;
